{
  "title": "Willkommen zurück",
  "subtitle": {
    "email": "Melde dich bei deinem Konto an",
    "password": "Gib dein Passwort ein",
    "magicLink": "Wir senden dir einen Anmeldelink",
    "setupPassword": "Passwort einrichten"
  },
  "buttons": {
    "loginMicrosoft": "Mit Microsoft anmelden",
    "loginMagicLink": "Mit Magic Link anmelden",
    "usePassword": "Stattdessen Passwort verwenden (nur für Sonderfälle)",
    "login": "Anmelden",
    "changeEmail": "E-Mail ändern",
    "forgotPassword": "Passwort vergessen?",
    "setupPassword": "Passwort einrichten",
    "sendLoginLink": "Anmeldelink senden"
  },
  "fields": {
    "email": "E-Mail",
    "password": "Passwort"
  },
  "errors": {
    "enterEmail": "Bitte gib deine E-Mail-Adresse ein",
    "enterPassword": "Bitte gib dein Passwort ein",
    "invalidCredentials": "Ungültige E-Mail oder Passwort",
    "notWhitelisted": "Passwort-Authentifizierung ist für dein Konto nicht verfügbar. Bitte melde dich mit Microsoft oder Google an.",
    "genericError": "Ein Fehler ist aufgetreten. Bitte versuche es erneut."
  },
  "messages": {
    "passwordRestricted": "Die Passwort-Anmeldung ist gemäß den Richtlinien deiner Organisation eingeschränkt. Die meisten Nutzer sollten die Microsoft- oder Google-Anmeldung oben verwenden.",
    "setupRequired": "Dein Konto ist für die Passwort-Authentifizierung freigegeben. Bitte lege ein Passwort fest, um fortzufahren.",
    "noPasswordSet": "Für dieses Konto ist kein Passwort festgelegt. Du kannst dich über einen Magic Link anmelden, der an deine E-Mail gesendet wird, oder kontaktiere deinen Administrator, um die Passwort-Authentifizierung einzurichten.",
    "magicLinkTooltip": "Mit dem Magic-Link-Login kannst du dich sicher ohne Passwort anmelden. Ein Link wird an die E-Mail-Adresse gesendet, die mit deinem Konto verknüpft ist."
  },
  "magicLinkPage": {
    "title": "Mit Magic Link anmelden",
    "description": "Gib unten deine E-Mail-Adresse ein, um einen Magic Link zum Anmelden zu erhalten.",
    "emailLabel": "E-Mail",
    "sendButton": "Senden",
    "successTitle": "Überprüfe deine E-Mails",
    "successMessage": "Eine E-Mail mit dem Betreff <u>Bei AirPlx anmelden</u> wurde an <u>{{email}}</u> gesendet. Klicke auf den Link in der E-Mail, um dich anzumelden."
  }
}
